/* ══════════════════════════════════════════════════════════════════════
   Skön Cosmetics — skon-gift-config.js
   asset: assets/skon-gift-config.js
   Modulo: Gift With Purchase (GWP) — configurazione UX cart-drawer
   Versione: 1.4.0
   Aggiornato: 2026-06-30 15:19 CEST (Europe/Rome)

   SCOPO
   ─────
   Default editabili del SOLO comportamento UX della barra omaggio. L'aggiunta
   /rimozione del prodotto omaggio dal carrello è governata da Dealeasy.
   Caricare PRIMA di skon-gift.js (vedi theme.liquid).

   FONTE DI VERITÀ
   ───────────────
   Da v1.4.0 i valori operativi vivono nel Customizer (Impostazioni tema →
   "Skön — Omaggio (GWP)") e arrivano qui via window.SKON_GIFT_SETTINGS (ponte
   skon-gift-settings.liquid). I default qui sotto sono solo il fallback se il
   ponte è assente. Il PRODOTTO omaggio si seleziona nel Customizer: il match
   "omaggio in carrello" avviene server-side in skon-gift-data.liquid sul
   product id selezionato (niente più tag).

   NOTA ICONE (v1.2)
   ─────────────────
   Le icone goal sono SVG a LINEA (stroke=currentColor), definite in
   skon-gift.js (costanti SVG_SHIP / SVG_GIFT). Non configurabili da qui.

   ── CHANGELOG ──────────────────────────────────────────────────────────
   v1.4.0 (2026-06-30): prodotto omaggio + tutte le 9 copy pilotabili dal
                        Customizer (merge esteso da SKON_GIFT_SETTINGS).
                        Match per prodotto selezionato (no tag). Wording Dealeasy.
   v1.3.0 (2026-06-24): on/off e soglia dal Customizer.
   v1.2.2 (2026-06-24): caption "raggiunto" più incisive; chipShippingDone.
   v1.2.1 (2026-06-24): copy headlineShipDoneOnly.
   v1.2.0 (2026-06-24): icone SVG a linea; stato pending "disabled".
   v1.1.0 (2026-06-24): marker spedizione al valore kit; marker omaggio in fondo.
   v1.0.0 (2026-06-23): prima release.
══════════════════════════════════════════════════════════════════════ */

window.SKON_GIFT_CONFIG = {

  /* Master on/off. false ⇒ il modulo esce subito: barra IDENTICA a FS. */
  enabled: true,

  /* Soglia omaggio, in CENTESIMI. Deve combaciare con la soglia Dealeasy. */
  threshold: 4900,

  /* Acceleratori di rilevamento lato JS (riserva). Il match primario è
     server-side per product id (skon-gift-data.liquid). productHandles viene
     popolato dal prodotto scelto nel Customizer tramite il ponte settings. */
  productVariantIds: [],
  productHandles:    [],

  /* legacy: il tag NON è più usato per il match omaggio (ora prodotto scelto
     nel Customizer). Lasciato inerte per retrocompatibilità. */
  tag: 'GWP',

  /* Copy — default di fallback. Sovrascritte dal Customizer quando presenti.
     {gap} = importo mancante. */
  copy: {
    chipShipping:     'Spedizione gratuita',
    chipShippingDone: 'Spedizione sbloccata',
    chipGiftPending:  'Prodotto Omaggio',
    chipGiftAdded:    'Omaggio aggiunto',

    headlineBothPending:         'Ti mancano {gap} a spedizione gratuita e prodotto omaggio',
    headlineShipDoneGiftPending: 'Spedizione gratuita sbloccata 🎉 Ti mancano {gap} per l’omaggio',
    headlineShipDoneOnly:        'Spedizione gratuita sbloccata 🎉',
    headlineGiftDoneShipPending: 'Omaggio aggiunto! Ti mancano {gap} alla spedizione gratuita',
    headlineComplete:            'Spedizione gratuita e omaggio sbloccati 🎉'
  }
};

/* ── Override dal Customizer (ponte snippets/skon-gift-settings.liquid) ──────
   Se window.SKON_GIFT_SETTINGS è presente, sovrascrive enabled / threshold /
   prodotto (handle) / copy sui default qui sopra. Assente ⇒ restano i default
   (retrocompatibile). Controlla SOLO la UX; l'aggiunta dell'omaggio resta
   gestita da Dealeasy. */
(function (s) {
  if (!s) return;
  var C = window.SKON_GIFT_CONFIG;

  if (typeof s.enabled === 'boolean') C.enabled = s.enabled;
  if (typeof s.thresholdCents === 'number' && s.thresholdCents > 0) C.threshold = s.thresholdCents;

  /* prodotto scelto nel Customizer → acceleratore JS di riserva per handle */
  if (s.productHandle) C.productHandles = [s.productHandle];

  /* copy: applica solo le stringhe valorizzate (campo vuoto ⇒ tiene il default) */
  if (s.copy) {
    for (var k in s.copy) {
      if (Object.prototype.hasOwnProperty.call(s.copy, k) &&
          typeof s.copy[k] === 'string' && s.copy[k].length) {
        C.copy[k] = s.copy[k];
      }
    }
  }
})(window.SKON_GIFT_SETTINGS);